import type { SharedApiV2 } from "@capstone/mock-api";
import { Day } from "src/app/core/day.model";
import { Site } from "src/app/core/sites";
import { TimeOfDay } from "src/app/core/time-of-day.model";
import { Weekdays } from "src/app/core/weekdays.model";
import { getApiDetailsDecorator } from "src/utils";
import { formatScheduleCutoffExceptionName } from "./schedule-cutoff-time-exception.model";

const api = getApiDetailsDecorator<SharedApiV2.DockCutoffExceptionDto>();

export class ScheduleCutoffTimeExceptionV2 {
  private constructor(
    args: Omit<ClassProperties<ScheduleCutoffTimeExceptionV2>, "name">,
  ) {
    this.customName = args.customName;
    this.cutoffTime = args.cutoffTime;
    this.endDay = args.endDay;
    this.id = args.id;
    this.startDay = args.startDay;
    this.weekdays = args.weekdays;
    this.site = args.site;

    // Computed properties
    this.name = this.customName || formatScheduleCutoffExceptionName(this);
  }

  @api({ key: "dayOfWeek" }) public readonly weekdays: Weekdays;
  @api({ key: "endDate" }) public readonly endDay: Day;
  @api({ key: "name" }) public readonly customName: string | null;
  @api({ key: "scheduleCutoffTime" }) public readonly cutoffTime: TimeOfDay;
  @api({ key: "startDate" }) public readonly startDay: Day;
  @api() public readonly id: number;
  public readonly site: Site;

  // Computed properties
  public readonly name: string;

  public static deserialize(
    data: SharedApiV2.DockCutoffExceptionDto,
    { site }: DeserializeArguments,
  ): ScheduleCutoffTimeExceptionV2 {
    return new ScheduleCutoffTimeExceptionV2({
      customName: data.name ?? null,
      cutoffTime: TimeOfDay.deserialize(data.scheduleCutoffTime),
      // TODO: update the deserialization to use the site time zone once implemented in the API
      // We deserialize the date to UTC as API ignores the site time zone.
      endDay: Day.deserialize(data.endDate, Day.utc),
      id: data.id,
      site,
      // TODO: update the deserialization to use the site time zone once implemented in the API
      // We deserialize the date to UTC as API ignores the site time zone.
      startDay: Day.deserialize(data.startDate, Day.utc),
      weekdays: Weekdays.deserialize(data.dayOfWeek),
    });
  }
}

interface DeserializeArguments {
  readonly site: Site;
}
